import { TutorialStep } from "@/components/tutorial/TutorialSpotlight";

// Export the tutorial steps for the Shopping page
export const shoppingPageTutorial: TutorialStep[] = [
  {
    target: ".shopping-header h1",
    title: "Nome della lista",
    content: "Questa è la tua lista della spesa attiva. Il nome mostra di quale lista si tratta.",
    position: "bottom"
  },
  {
    target: "button[aria-label='Cerca articoli']",
    title: "Cerca articoli",
    content: "Usa questo pulsante per cercare rapidamente articoli nella tua lista.",
    position: "bottom"
  },
  {
    target: "button[aria-label='Ordina articoli']",
    title: "Ordina articoli",
    content: "Ordina gli articoli per facilitare la tua spesa, ad esempio per categoria o nome.",
    position: "bottom"
  },
  {
    target: ".tutorial-target-shoppingheader-mode",
    title: "Modalità lista",
    content: "Passa rapidamente tra le modalità Spesa e Prepara.",
    position: "bottom"
  },
  {
    target: "button[aria-label='Impostazioni lista']",
    title: "Impostazioni lista",
    content: "Qui puoi configurare le opzioni della lista come l'inserimento rapido o il negozio associato.",
    position: "left"
  },
  // {
  //   target: "button[aria-label='Condividi lista']",
  //   title: "Condividi lista",
  //   content: "Condividi questa lista con amici o familiari per collaborare insieme.",
  //   position: "left",
  // },
  {
    target: ".category-filters",
    title: "Filtro per categoria",
    content: "Filtra gli articoli per categoria per organizzare meglio la tua spesa.",
    position: "top"
  }
];

